<script>
    import _           from 'lodash'
    import { fade }    from 'svelte/transition'
    import * as api    from '../../../shared/api.js'    
    import Modal       from '../../../shared/SemanticModal.svelte'
    import Scopes      from '../../../shared/Scopes.svelte'
    import ScopedField from './ScopedField.svelte'

    export let place
    export let domain
    export let config
    export let disabled

    let mode       = ''
    let scope      = 'SAR'
    let keys       = place.fields.filter(f => f.key)
    let values     = Object.fromEntries(keys.map(f => [f.definition, null]))
    let testing    = false
    let loading    = false
    let testingErr = false
    let responses  = []

    function enableMode(desired) {
        return evt => {
            mode = desired
        }
    }

    function disableMode(desired) {
        return evt => {
            mode       = ''
            scope      = 'SAR'
            testing    = false
            responses  = []
            testingErr = false
        }
    }

    function testEndpoint(evt) {

        const mapKeys = values => {
            let result = []
            Object.keys(values).forEach(key => {
                result.push({
                    place: place.id,
                    field: place.fields.find(f => f.definition === key).id,
                    value: values[key]
                })
            })
            return result
        }

        testing    = true
        loading    = true
        responses  = []
        testingErr = false

        const cfg = _.omitBy({ active: true, ...config }, i => i === '')
        api
            .post(`/inventory/domain/${domain.id}/connector/test`, {
                place   : place.id,
                keys    : mapKeys(values),
                scope   : scope,
                config  : cfg
            })
            .then(api.toJsonIf200)
            .then(response => {
                responses = response.data || []
                loading = false
            })
            .catch(err => {
                testingErr = err.statusText
                loading = false
            })
    }

</script>

<button class="ui button"
        class:disabled
        on:click|preventDefault={enableMode('test')}>
    Testar
</button>    

{#if mode === 'test'}
    <div class="test" transition:fade>
        <h3>Chaves</h3>
        <form class="ui form">
            {#each keys as field}
                <div class="field" class:disabled={false}>
                    <label>{field.definition}</label>
                    <input bind:value={values[field.definition]}>
                </div>
            {/each}
        </form>

        <div class="split">
            <div style="flex: 1">
                <h3>Escopo</h3>
                <Scopes bind:scope></Scopes>
            </div>            
            <div style="flex: 1">
                <h3>Campos</h3>
                <div class="ui list">
                    {#each place.fields as field (field.id)}
                        <ScopedField {field} {scope}></ScopedField>
                    {/each}
                </div>
            </div>
        </div>

        <button class="ui button" on:click|preventDefault={testEndpoint}>Executar</button>
    </div>
{/if}

<Modal active={testing}>
    <div class="ui tiny modal visible active">
        <div class:active={loading} class="ui inverted dimmer">
            <div class="ui loader"></div>
        </div>
        <div class="header">
            Teste de Integração
        </div>
        <div class="scrolling content">
            {#if testingErr}
                <div class="ui red label">
                    {testingErr}
                </div>                
            {:else}
                <div class="ui list">
                    {#each place.fields as field (field.id)}
                        <ScopedField {field} {scope} {responses}></ScopedField>
                    {/each}
                </div>
            {/if}
        </div>
        <div class="actions">
            <div class="ui black button" on:click={disableMode('test')}>Fechar</div>
        </div>            
    </div>
</Modal>

<style>
    .test {
        margin: 2em 0;
    }
    .split {
        display: flex;
        margin: 1em 0;
    }
</style>

